/**
 * Extract primitive or react-select `.value` — used across trade/position report thunks.
 */
export function extractSelectOrPrimitive(obj) {
  if (obj === null || obj === undefined) return null;
  if (typeof obj !== "object") return obj;
  return "value" in obj ? obj.value ?? null : null;
}
